import { render, staticRenderFns } from "./screen-preview.vue?vue&type=template&id=2239e62e&"
import script from "./screen-preview.vue?vue&type=script&lang=js&"
export * from "./screen-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports